export enum TransactionServiceKeys {
  GET_BALANCE = 'GET_BALANCE',
  GET_BANK_INFO = 'GET_BANK_INFO',
  GET_TRANSACTION_DETAILS = 'GET_TRANSACTION_DETAILS',
}
